module.exports = __webpack_public_path__ + "img/001.c6dc094b.jpg";